const getItem = key => {
  try {
    const value = localStorage.getItem(key);
    return value;
  } catch (error) {
    return null;
  }
};

export default getItem;
